import AssetFormWrapper from "../../components/asset-forms/AssetFormWrapper";

/**
 * Important Papers Asset Edit View
 * Now uses the unified AssetFormWrapper component
 */
const ImportantPapersView = ({ assetId, startInEditMode }) => {
  return (
    <AssetFormWrapper
      mode="edit"
      subCategory="important-papers"
      assetId={assetId}
      startInEditMode={startInEditMode}
    />
  );
};

export default ImportantPapersView;
